<template>
    <div>İndex</div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sim/_/index.vue